var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaceholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#eeebfa;stroke:#5839cb;stroke-width:0.2px;}.b{fill:#5839cb;}.c{stroke:none;}.d{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6155 -6752)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(6155 6752)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 20,
    cy: 20,
    r: 20
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 20,
    cy: 20,
    r: 19.9
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6120.007 6732)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M158.45,33.164a3.816,3.816,0,0,0-5.48-.007,3.78,3.78,0,0,0-.96,2.885,3.711,3.711,0,1,0,7.405,0A3.769,3.769,0,0,0,158.45,33.164Z",
    transform: "translate(-100.29 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M61.709,294.857H49.137a1.107,1.107,0,0,1-.864-.4,1.261,1.261,0,0,1-.256-1.04,6.115,6.115,0,0,1,2.721-4.063,8.767,8.767,0,0,1,9.371,0,6.113,6.113,0,0,1,2.721,4.063,1.261,1.261,0,0,1-.256,1.04A1.107,1.107,0,0,1,61.709,294.857Z",
    transform: "translate(0 -246.857)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.0fded40adf7d05abe7e980567982e42e.svg";
export { ForwardRef as ReactComponent };